import { Field, FieldKinds, TableRow } from '@site-mate/dashpivot-shared-library';

import { FormFieldHeaderColumn } from 'app/form-fields/common/register/form-field-header/form-field-header-column';

import { TableColumnsFactory } from './table-columns-factory';
import { TableHeader } from './table-header';
import { FormField } from '../../common/register/form-field';

export class Table extends FormField {
  constructor(item: Field, header: TableHeader, metadata?: Record<string, string>) {
    super(item, header);
    this.grid = [];
    const isPrefilled = (header.kind as FieldKinds) === FieldKinds.PrefilledTable;

    const isHeaderKindDifferentFromItemKind = (header.kind as string) !== (item.kind as string);

    // Display at least one row
    if (!item?.rows?.length) {
      item.rows = [{} as any];
    }
    const fieldColumns = item.columns || [];

    this.grid = item.rows.map((row: TableRow, index: number) => {
      const rowSpan = index === item.rows.length - 1 ? 0 : 1;

      return header.columns.map((hc: FormFieldHeaderColumn, headerIndex) => {
        const columnItem = this.getRowColumnItem(row, hc, headerIndex, fieldColumns) || {};
        const tableColumn = {
          columnItem,
          isPrefilled,
          header: hc,
          rowSpan,
          metadata,
          isHeaderKindDifferentFromItemKind,
        };

        return TableColumnsFactory.getTableColumn(tableColumn);
      });
    });
  }

  private getRowColumnItem(
    row: TableRow,
    headerColumn: FormFieldHeaderColumn,
    headerIndex: number,
    fieldColumns: any[],
  ) {
    // there are some old templates which don't have header column ids defined
    // so it is not possible to match template headers with form fields
    // in this cases we fall back to index of the template header column
    const index = headerColumn.id
      ? fieldColumns.findIndex((column) => column.id === headerColumn.id)
      : headerIndex;

    return row.columns ? row.columns[index] : null;
  }
}
